import { HelpcenterPageType } from '@wix/answers-api';
import * as React from 'react';
import { deepSearch } from '../../../../common/utils';
import { useFedopsLogger as getFedopsLogger } from '../../../utils/fedops-logger';
import { NavLinkJsx } from '../nav-link-jsx';
import { Logger } from '@wix/bi-logger-wix-answers';

export const CategoryNavLink = ({
  model,
  biLogger,
}: {
  model: any;
  biLogger: Logger;
}) => (props) => {
  const { id: categoryId, children, page } = props;
  const { categoryTree } = model;
  const category = deepSearch<any, any>(
    categoryTree,
    'children',
    (item) => item.id === categoryId,
  );
  const { uri = '', name } = category;
  const fedopsLogger = getFedopsLogger();

  const onCategoryClick = () => {
    fedopsLogger.startInteraction('category_navigation');
    if (page === `${HelpcenterPageType.HOMEPAGE}`) {
      return biLogger.publicSelectCategoryOrSubcategory({
        category_id: categoryId,
        category_name: name,
        answers_brand_id: model.tenant.brandId,
      });
    }
  };

  return (
    <NavLinkJsx uri={uri} state={categoryId} onClick={onCategoryClick}>
      {children}
    </NavLinkJsx>
  );
};
